import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    SHOW_MESSAGE,
    INIT_URL,
    SET_SOCKET
  } from "../types";
import axios from "../../services/Api";
import { encryptData } from "../../services/Api"; 
import history from "../../services/history";
import { showToast } from "../../services/functions";
  
  
export const setInitUrl = (url) => {
    return {
        type: INIT_URL,
        payload: url
    };
};

export const dummyAction = (url) => {
  return {
    type: "DUMMY",
    payload: "shavika"
  };
};

export const userLogin = (payload, callback) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    axios
      .post('users/login', {
        ...payload,
      })
      .then(({ data }) => {
        if (data.success) {
          if (data.twoFactorAuth === true) {
            axios.defaults.headers.common['authorization'] = data.resendOtpToken;
            // Pass response to callback for 2FA handling
            //   localStorage.setItem("token", JSON.stringify(data.resendOtpToken));
            // localStorage.setItem("user", JSON.stringify(data.resendOtpToken));
            dispatch({ type: FETCH_SUCCESS, payload: data });
            if (callback) callback(data, null);
          } else {
            // Complete login process for non-2FA cases
            afterLoginProcess();
            dispatch({ type: FETCH_SUCCESS, payload: data });
            if (callback) callback(data, null);
          }
        } else {
          dispatch({ type: FETCH_ERROR, payload: data.message });
          // showToast(data.message, true);
          if (callback) callback(null, data.message);
        }

        function afterLoginProcess() {
          localStorage.setItem("token", JSON.stringify(data.token));
          localStorage.setItem("user", JSON.stringify(data.user));
          axios.defaults.headers.common['authorization'] = data.token;
          dispatch({ type: FETCH_SUCCESS });
          history.push(data.initUrl || "/dashboard");
        }
      })
      .catch(function (error) {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        showToast(error.message, true);
        if (callback) callback(null, error.message);
      });
  };
};

export const setSocket = (socket) => {
  return {
    type: SET_SOCKET,
    payload: socket
  };
};
